import React from 'react'
import { SubmitErrorListener } from '@components/ui/SubmitErrorListener'
import { ClaimAcceptedListener } from '@components/ui/ClaimAcceptedListener'
import { AppContainer } from '../AppContainer/AppContainer'
import { AppWithSessionHOC, AppWithSessionProps } from './AppHOC'

const CtaContainer = React.lazy(() => import('@components/CTA/CtaContainer'))

export const DirectBillingApp: React.FC<AppWithSessionProps> = props => {
  const { session, actionModule, environment } = props
  return (
    <AppWithSessionHOC session={session} environment={environment} actionModule={actionModule}>
      <CtaContainer />
      <AppContainer />
      <ClaimAcceptedListener />
      <SubmitErrorListener nonRetryableErrorsOnly />
    </AppWithSessionHOC>
  )
}
